/** @format */
import feedbackFeatureToggleRedirect from 'sis-components/feedback/feedback-feature-toggle-redirect';
import { genericFeedbackState, genericFeedbackThankYouState } from 'sis-components/feedback/feedback.route';
import { SisStateDeclaration } from 'sis-components/router/types';
import { studentRoutes } from '../auth/student-routes';

export const feedbackRoutes: SisStateDeclaration[] = [
    // /student/feedback
    {
        ...genericFeedbackState,
        name: 'student.logged-in.feedback',
        redirectTo: feedbackFeatureToggleRedirect(studentRoutes.defaultView),
    },
    // /student/feedback/thank-you
    {
        ...genericFeedbackThankYouState,
        name: 'student.logged-in.feedback-thank-you',
        resolve: {
            homeState: () => studentRoutes.defaultView,
        },
        redirectTo: feedbackFeatureToggleRedirect(studentRoutes.defaultView),
    },
];
